import { Video, MapPin, FileText, Plane } from 'lucide-react';

const modules = [
  {
    icon: Video,
    title: 'AI Video Stüdyo',
    description: 'Konut fotoğraflarınızdan sesli ve altyazılı profesyonel tanıtım videoları oluşturun. Yapay zeka seslendirme ile çoklu dil desteği.',
    features: ['Fotoğraftan video', 'AI seslendirme', 'Çoklu dil', 'Altyazı'],
    color: 'from-blue-500 to-primary',
  },
  {
    icon: MapPin,
    title: 'Gayrimenkul Araştırma',
    description: 'Bir adres girin, çevredeki önemli lokasyonları (POI) keşfedin. Otomatik ilan metni ve analiz raporu oluşturun.',
    features: ['POI keşfi', 'Otomatik analiz', 'İlan metni', 'Raporlama'],
    color: 'from-emerald-500 to-teal-600',
  },
  {
    icon: FileText,
    title: 'İlan Analizi & İnfografik',
    description: 'Mevcut ilan linkinden içerik çıkarımı. NotebookLM benzeri akıllı özet ve görsel infografik üretimi.',
    features: ['Link analizi', 'İçerik çıkarımı', 'AI özet', 'Infografik'],
    color: 'from-violet-500 to-purple-600',
  },
  {
    icon: Plane,
    title: 'Parsel & Sanal Drone',
    description: 'TKGM sorgu sonucu harita üzerinde alan çizimi. Parsel sınırlarından sanal drone tanıtım videosu üretimi.',
    features: ['TKGM entegrasyonu', 'Alan çizimi', 'Sanal drone', 'Parsel video'],
    color: 'from-orange-500 to-amber-600',
  },
];

export default function Modules() {
  return (
    <section id="modules" className="section-padding bg-slate-50 dark:bg-slate-900/50">
      <div className="container-custom">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full 
                          bg-primary/10 text-primary text-sm font-semibold mb-4">
            Ürün Modülleri
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-slate-900 dark:text-white">
            Her İhtiyaca Uygun <span className="gradient-text">Çözümler</span>
          </h2>
          <p className="text-slate-600 dark:text-slate-400 max-w-2xl mx-auto text-lg">
            Maplio, gayrimenkul profesyonelleri için tasarlanmış 4 ana modül ile 
            kapsamlı bir içerik üretim platformu sunar.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
          {modules.map((module) => (
            <div
              key={module.title}
              className="group card p-8 hover:scale-[1.02] transition-all duration-300 
                         cursor-pointer overflow-hidden relative"
            >
              {/* Gradient background on hover */}
              <div className={`absolute inset-0 bg-gradient-to-br ${module.color} 
                              opacity-0 group-hover:opacity-5 transition-opacity duration-300`} />
              
              <div className="flex flex-col sm:flex-row gap-6 relative z-10">
                {/* Icon */}
                <div className={`shrink-0 w-16 h-16 rounded-2xl bg-gradient-to-br ${module.color} 
                                flex items-center justify-center shadow-lg 
                                group-hover:scale-110 transition-transform duration-300`}>
                  <module.icon className="w-8 h-8 text-white" />
                </div>

                <div className="flex-1">
                  <h3 className="text-xl font-bold mb-3 text-slate-900 dark:text-white 
                                 group-hover:text-primary transition-colors">
                    {module.title}
                  </h3>
                  <p className="text-slate-500 dark:text-slate-400 mb-4 leading-relaxed">
                    {module.description}
                  </p>
                  
                  {/* Features */}
                  <div className="flex flex-wrap gap-2">
                    {module.features.map((feature) => (
                      <span
                        key={feature}
                        className="px-3 py-1 text-xs font-medium rounded-full 
                                   bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
